import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { Menu, X } from "lucide-react";
import ReactDOM from "react-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const handleWhatsApp = () => {
    window.open("https://wa.me/919934743600", "_blank");
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setIsMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed w-full top-0 transition-all duration-300 z-50 ${
          isScrolled
            ? "bg-white/90 backdrop-blur-lg shadow-xl"
            : "bg-white/90 backdrop-blur-sm shadow-xl"
        }`}
      >
        <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <img
                src="/img/caindia.webp"
                alt="ICAI India"
                className="h-8 mr-3 md:mr-7"
              />
              <Link
                to="/#home"
                onClick={() => scrollToSection("home")}
                className="text-2xl font-bold text-transparent bg-gradient-to-r from-blue-900 to-blue-600 bg-clip-text"
              >
                Govind Sinha & Co.
              </Link>
            </div>

            {/* Desktop Menu */}
            <div className="items-center hidden lg:flex">
              <div className="flex items-baseline ml-10 space-x-4">
                <Link
                  to="/"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="nav-link"
                >
                  Home
                </Link>
                <Link
                  to="/services"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="nav-link"
                >
                  Services
                </Link>
                <Link
                  to="/checklists"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="nav-link"
                >
                  Checklists
                </Link>
                <Link to="/#resources" className="nav-link">
                  Resources
                </Link>
                <Link to="/#about" className="nav-link">
                  About
                </Link>
                {/* <Link
                  to="/pay"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="nav-link"
                >
                  Payment
                </Link> */}
                <Link to="/#contact" className="nav-link">
                  Contact
                </Link>
              </div>
              <button
                onClick={handleWhatsApp}
                className="flex items-center px-4 py-2 ml-6 space-x-2 text-sm font-medium text-white transition-all duration-300 transform bg-green-500 rounded-full shadow-lg hover:bg-green-600 hover:scale-105"
              >
                <FaWhatsapp className="w-5 h-5" />
                <span>+91 9934743600</span>
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 transition-colors hover:text-blue-600"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      isMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen &&
          ReactDOM.createPortal(
            <div className="fixed top-16 left-0 w-full border-t lg:hidden bg-white/90 backdrop-blur-md shadow-lg z-[51]">
              <div className="px-2 pt-2 pb-3 space-y-1">
                <Link
                  to="/"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="mobile-nav-link"
                >
                  Home
                </Link>
                <Link
                  to="/services"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="mobile-nav-link"
                >
                  Services
                </Link>
                <Link
                  to="/checklists"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="mobile-nav-link"
                >
                  Checklists
                </Link>
                <Link to="/#resources" className="mobile-nav-link">
                  Resources
                </Link>
                <Link to="/#about" className="mobile-nav-link">
                  About
                </Link>
                {/* <Link
                  to="/pay"
                  // onClick={() => window.scrollTo(0, 0)}
                  className="mobile-nav-link"
                >
                  Payment
                </Link> */}
                <Link to="/#contact" className="mobile-nav-link">
                  Contact
                </Link>
              </div>
            </div>,
            document.getElementById("mobile-menu-root")
          )}
      </nav>
    </>
  );
};

export default Navbar;
